// extracted by mini-css-extract-plugin
module.exports = {"mySwiper":"AdBanner_mySwiper__TM2Rx","bannerDiv":"AdBanner_bannerDiv__BltPi","skeleton_banner":"AdBanner_skeleton_banner__ma8zx","shimmer":"AdBanner_shimmer__1HqBu"};